import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_42evg3vp59: FaireBrandEntity = {
  token: "b_42evg3vp59",
  type: "brand",
  name: "Clean Monday Meals",
  avatarUrl:
    "https://cdn.faire.com/fastly/8d9e85f07ea56cec9bd2d734e3a9f51f24237e847a91742f85fd640007c573cd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/311b449bd3db7273db0aa1883e9d17838da4f0004352723618fcfbe776c8bfb9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8d9e85f07ea56cec9bd2d734e3a9f51f24237e847a91742f85fd640007c573cd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/311b449bd3db7273db0aa1883e9d17838da4f0004352723618fcfbe776c8bfb9.jpeg",
  location: "Manti, UT, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 15,
  isTopShop: true,
  isInsider: true,
  description:
    "Hello! I'm Janae Cox, a wife, and mom to five wonderful kids. My journey into the world of clean eating and living a gluten and dairy-free lifestyle began with my own health struggles. In 2014, I was diagnosed with Celiac Disease and shortly after, PCOS (polycystic ovary syndrome). These diagnoses were life-changing, but they also sparked a passion in me to find and share solutions that make living with these conditions easier.\n\nShortly after Cealiac Disease forced my lifestyle to change I started an Instagram page called @cleanmondaymeals. Initially, it was just a space for me to share my gluten-free meal prep ideas, with no expectations of it becoming anything more. But it grew into a vibrant community of like-minded individuals who are all striving to eat healthier and feel better.\n\nTogether, we can make clean eating a delicious and effortless part of our lives. Let's nourish our bodies and thrive together!\n\nWith love,\nJanae Cox",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:22.124Z",
    importedBy: "entity-db-cli",
  },
};
